import { render } from "./mock.vue?vue&type=template&id=0bd43f2c&scoped=true"
import script from "./mock.vue?vue&type=script&lang=js"
export * from "./mock.vue?vue&type=script&lang=js"

import "./mock.vue?vue&type=style&index=0&id=0bd43f2c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd43f2c"]])

export default __exports__